<template>
    <div class="login-page">
        <div class="login-content">
            <div class="login-title">找回密码</div>
            <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="0" class="login-formstyle">
                <FormItem class="itemss" prop="phone" ref="mp">
                    <div class="login-names">用户名：</div>
                    <Input type="text" v-model="formData.phone" @keyup.enter.native="conSubmit"></Input>
                </FormItem>
                <FormItem class="itemss" prop="new_password">
                    <div class="login-names">新密码：</div>
                    <Input type="password" v-model="formData.new_password" @keyup.enter.native="conSubmit"></Input>
                </FormItem>
                <FormItem class="itemss" prop="new_password_confirm">
                    <div class="login-names">确认新密码：</div>
                    <Input type="password" v-model="formData.new_password_confirm" @keyup.enter.native="conSubmit"></Input>
                </FormItem>
                <FormItem class="itemss" prop="captcha">
                    <div class="login-names">验证码：</div>
                    <div style="display:flex">
                        <Input type="text" v-model="captcha" style="width: 200px"></Input>
                        <img @click="changeCaptcha" :src="captchaurl" class="login-imgs"/>
                    </div> 
                </FormItem>
                <FormItem class="itemss" prop="mobile_code">
                    <div class="login-names">手机验证码：</div>
                    <div style="display:flex">
                        <Input type="text" v-model="formData.mobile_code" @keyup.enter.native="conSubmit" style="width: 200px"></Input>
                        <Getvalidate slot="icon" @click="codes"></Getvalidate>
                    </div> 
                </FormItem>
                <FormItem  class="login-btn">          
                    <Row>
                        <Col span="12">
                            <Button :disabled="disabled" type="primary" @click="conSub('formData')" class="login-btn-sub">找回密码</Button>
                        </Col>
                        <Col span="12">
                            <Button :disabled="disabled" type="success" @click="toLogin" class="login-btn-sub">去登录</Button>       
                        </Col>
                    </Row>    
                </FormItem>
                <div class="login-support">@八零传媒 版权所有</div>
            </Form>
        </div>
    </div>
</template>
<script>
import isValid from '../../common/isValid.js';
import common from '@/common/common.js';
import Getvalidate  from './timer';
    export default {
        data() {
            return {
                captchaurl:'',
                formData: {
                    new_password_confirm: '',
                    new_password: '',
                    phone: '',
                    mobile_code: ''
                },
                captcha: '',
                ruleCustom: {
                    phone: [
                        { validator: this.phoneRules, trigger: 'blur' }
                    ],
                    new_password: [
                        { required: true, message: '密码必须填写', trigger: 'blur' },
                        { min: 6, max: 15, message: '密码长度6 - 15', trigger: 'blur' }
                    ],
                    new_password_confirm: [
                        { required: true, message: '确认密码必须填写', trigger: 'blur' },
                        { min: 6, max: 15, message: '密码长度6 - 15', trigger: 'blur' }
                    ],
                    mobile_code: [
                        { required: true, message: '手机验证码必须填写', trigger: 'blur' }
                    ]
                },
                disabled: false
            }
        },
        components: {
            Getvalidate
        },
        methods: {
            phoneRules(rule, value, callback){
                let reg = /^1(3|4|5|7|8)\d{9}$/;
                if(!reg.test(value)) {
                    return callback(new Error('手机号格式错误'));
                }
                callback();
            },
            conSub(name) {
                this.$refs[name].validate((valid) => {          
                    if (valid) {
                        this.disabled = true;
                        if(this.formData.new_password != '' && this.formData.new_password_confirm != ''){
                            if(this.formData.new_password != this.formData.new_password_confirm){
                                common.msg('error','新密码与确认新密码不一致',()=>{this.disabled = false;})
                                return false
                            }                
                        }
                        this.axios.post(this.config.urlArray.forgetPassword, this.formData).then((result) => {
                            common.ajaxMsg(result.data,true,()=>{
                                this.getCaptcha();
                                this.$router.push({path: '/login'})
                            },()=>{this.disabled = false;}) 
                        }).catch((err) => {
                            common.msg('error','设置失败')
                        }); 
                    }
                })
            },
            conSubmit(event) { // enter快捷键
                event = event || window.event;
                if (event.keyCode === 13) {
                    this.conSub('formData');
                }
            },
            changeCaptcha() {
                this.getCaptcha();
            },
            getCaptcha() {
                this.axios.get(this.config.urlArray.captcha,{}).then((res)=>{
                    this.captchaurl = res.data.img;
                    this.captchaurl = res.data.data.url;
                })
            },
            codes(cd) {
                let mobilephone = this.formData.phone;
                let reg = /^1(3|4|5|7|8)\d{9}$/;
                if (!reg.test(mobilephone)) {
                    common.msg('error','手机号格式错误')
                } else if (this.formData.new_password == '' || this.formData.new_password_confirm == ''){
                    common.msg('error','请输入密码')          
                } else if (this.captcha == '') {
                    common.msg('error','请填写验证码')
                } else {
                    let data = {
                        phone: this.formData.phone,
                        captcha: this.captcha
                    }
                    this.axios.post(this.config.urlArray.sendSms, data).then((result) => {
                        common.ajaxMsg(result.data,true,()=>{
                            cd()
                        },()=>{this.getCaptcha();}) 
                    }).catch((err) => {
                        common.msg('error','获取失败')
                    }); 
                }
            },
            toLogin() {
                this.$router.push({path: '/login'})
            }
        },
        mounted:function (){
            this.getCaptcha();
        }
    }
</script>
<style scoped>
#app {
    width: 100%;
    height: 100%;
}
.login-page {
    width: 100%;
    height: 100vh;
    background: #4F5A6E;
}
.login-content {
    width: 400px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -200px;
    margin-top: -280px;
}
.login-title {
    width: 100%;
    height: 50px;
    background: #2d8cf0;
    color: #fff;
    line-height: 50px;
    text-align: center;
    font-size: 20px;
}
.login-formstyle {
    background: #fff;
    width: 400px;
    padding: 20px 30px 10px 30px
}
.login-btn {
    width: 100%;
    height: 40px;
    margin-top: 20px;
}
.login-btn-sub {
    width: 96%;
}
.login-names {
    margin-top: 10px;
}
.login-imgs {
    margin-left: 10px;
    height: 32px;
}
.login-support {
    width: 100%;
    text-align: center;
    font-size: 12px;
    margin-top: 30px;
}
.ivu-form-item {
    margin-bottom: 0 !important;
}
</style>
<style>
.login-page .ivu-form-item-content{
    margin-left: 0 !important;
}
</style>

